import { DELETE_WATCH_LIST_ENTRY_HIGH_RISK_COUNTRIES } from "../types";
import createAsyncActions from "../../../utilities/createAsyncActions";

export const {
  deleteWatchListEntry,
  deleteWatchListEntryPending,
  deleteWatchListEntryFulfilled,
  deleteWatchListEntryRejected,
} = createAsyncActions(
  DELETE_WATCH_LIST_ENTRY_HIGH_RISK_COUNTRIES,
  "deleteWatchListEntry"
);



// WEBPACK FOOTER //
// ./src/features/watch-list-entry-high-risk-country/actions/deleteWatchListEntryActions.js